"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
// @ts-ignore wrong typings with no default export
var unfetch_1 = tslib_1.__importDefault(require("unfetch"));
var mobx_react_1 = require("mobx-react");
var formstate_1 = require("formstate");
var react_hcaptcha_1 = tslib_1.__importDefault(require("@hcaptcha/react-hcaptcha"));
var utils_1 = require("../../utils");
var UserFormState;
(function (UserFormState) {
    UserFormState[UserFormState["Default"] = 0] = "Default";
    UserFormState[UserFormState["Loading"] = 1] = "Loading";
    UserFormState[UserFormState["Error"] = 2] = "Error";
    UserFormState[UserFormState["Success"] = 3] = "Success";
})(UserFormState || (UserFormState = {}));
var ClaimForm = /** @class */ (function (_super) {
    tslib_1.__extends(ClaimForm, _super);
    function ClaimForm(props) {
        var _this = _super.call(this, props) || this;
        _this.userForm = new formstate_1.FormState({
            username: new formstate_1.FieldState('')
                .disableAutoValidation()
                .validators(function (val) { return !val && 'Введите Ваше имя'; }),
            contact: new formstate_1.FieldState('').disableAutoValidation().validators(function (val) {
                var isValidEmail = /.+@.+/gim.test(val);
                var cleanPhone = val.replace(/[()\s-+]/gim, '');
                var isValidPhone = /\d{11,}/gim.test(cleanPhone);
                if (isValidEmail || isValidPhone) {
                    return false;
                }
                else {
                    return 'Введите полный номер телефона (минимум 11 цифр) или корректный адрес электронной почты';
                }
            }),
            comment: new formstate_1.FieldState(''),
        });
        _this.captchaRef = react_1.default.createRef();
        _this.onSubmit = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var userForm, result, token;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        clearTimeout(this.timerId);
                        if (this.state.userFormState === UserFormState.Loading) {
                            return [2 /*return*/];
                        }
                        utils_1.metrika(utils_1.metrikaGoals.formSubmit);
                        userForm = this.userForm;
                        return [4 /*yield*/, userForm.enableAutoValidationAndValidate()];
                    case 1:
                        result = _a.sent();
                        if (result.hasError) {
                            console.error(userForm.error);
                            return [2 /*return*/];
                        }
                        this.setState({ userFormState: UserFormState.Loading });
                        return [4 /*yield*/, this.captchaRef.current.execute({
                                async: true,
                            })];
                    case 2:
                        token = _a.sent();
                        unfetch_1.default('/api/send-mail', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                name: userForm.$.username.$,
                                comment: userForm.$.comment.$,
                                contact: userForm.$.contact.$,
                                token: token.response,
                            }),
                        })
                            .then(function (r) { return r.json(); })
                            .then(function (response) {
                            if (response.isError) {
                                _this.setUserFormState(UserFormState.Error);
                                utils_1.metrika(utils_1.metrikaGoals.formError);
                                utils_1.sentryReport('Email service error');
                            }
                            else {
                                _this.setUserFormState(UserFormState.Success);
                                utils_1.metrika(utils_1.metrikaGoals.formSuccess);
                            }
                        })
                            .catch(function (error) {
                            _this.setUserFormState(UserFormState.Error);
                            utils_1.metrika(utils_1.metrikaGoals.formError);
                            utils_1.sentryReport(error);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setUserFormState = function (newState) {
            _this.setState({ userFormState: newState });
            _this.timerId = setTimeout(function () {
                _this.setState({ userFormState: UserFormState.Default });
            }, 3000);
        };
        _this.state = {
            userFormState: UserFormState.Default,
        };
        return _this;
    }
    ClaimForm.prototype.render = function () {
        var userForm = this.userForm;
        var userFormState = this.state.userFormState;
        return (react_1.default.createElement("div", { className: "claim" },
            react_1.default.createElement("div", { className: "claim__title" }, "\u041E\u0441\u0442\u0430\u043B\u0438\u0441\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u044B?"),
            react_1.default.createElement("div", { className: "claim__text" }, "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0443 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0432\u044F\u0437\u0438 \u0438 \u043D\u0430\u0448\u0438 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u044B \u0441\u0432\u044F\u0436\u0443\u0442\u0441\u044F \u0441 \u0432\u0430\u043C\u0438 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F"),
            userFormState === UserFormState.Success && (react_1.default.createElement("div", { className: "claim__status" },
                react_1.default.createElement("div", { className: "claim__status-content" },
                    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 24 24" },
                        react_1.default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
                        react_1.default.createElement("path", { fill: "#8ad282", d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" })),
                    "\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430"))),
            userFormState === UserFormState.Error && (react_1.default.createElement("div", { className: "claim__status" },
                react_1.default.createElement("div", { className: "claim__status-content" },
                    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 24 24" },
                        react_1.default.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
                        react_1.default.createElement("path", { fill: "#ff6347", d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" })),
                    "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430, \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435"))),
            react_1.default.createElement("form", { className: "claim__form", onSubmit: this.onSubmit },
                react_1.default.createElement("div", { className: "claim__row" },
                    react_1.default.createElement(InputField, { placeholder: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F", fieldState: userForm.$.username }),
                    react_1.default.createElement(InputField, { placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B", fieldState: userForm.$.contact })),
                react_1.default.createElement("label", { className: "claim__field" },
                    react_1.default.createElement("textarea", { className: "claim__input", placeholder: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F", value: userForm.$.comment.value, onChange: function (e) { return userForm.$.comment.onChange(e.target.value); } })),
                react_1.default.createElement("button", { type: "submit", className: "claim__button", disabled: userFormState === UserFormState.Loading },
                    "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
                    userFormState === UserFormState.Loading && (react_1.default.createElement("div", { className: "claim__status-loader" },
                        react_1.default.createElement("div", { className: "circle-loader" })))),
                react_1.default.createElement(react_hcaptcha_1.default, { ref: this.captchaRef, size: "invisible", sitekey: "7a78b6f8-52ec-4836-89c4-8f5917127025" }))));
    };
    ClaimForm = tslib_1.__decorate([
        mobx_react_1.observer
    ], ClaimForm);
    return ClaimForm;
}(react_1.default.Component));
exports.ClaimForm = ClaimForm;
var InputField = /** @class */ (function (_super) {
    tslib_1.__extends(InputField, _super);
    function InputField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputField.prototype.render = function () {
        var _a = this.props, fieldState = _a.fieldState, placeholder = _a.placeholder;
        return (react_1.default.createElement("label", { className: "claim__field" },
            react_1.default.createElement("input", { type: "text", className: "claim__input", placeholder: placeholder, value: fieldState.value, onChange: function (e) { return fieldState.onChange(e.target.value); } }),
            fieldState.error && react_1.default.createElement("div", { className: "claim__error" }, fieldState.error)));
    };
    InputField = tslib_1.__decorate([
        mobx_react_1.observer
    ], InputField);
    return InputField;
}(react_1.default.Component));
exports.InputField = InputField;
exports.ClaimFormSection = function () { return (react_1.default.createElement("div", { className: "section section_blue" },
    react_1.default.createElement(ClaimForm, null))); };
